import React, { Component } from "react";
import LevelSection from "./components/LevelSection/LevelSection";
import SourceSection from "./components/SourceSection/SourceSection";
import TopicSection from "./components/TopicSection/TopicSection";
import MyExercisesSection from "./components/MyExercisesSection/MyExercisesSection";

export default class ExerciseListSidePanel extends Component {
  render() {
    return (
      <>
        <LevelSection location={this.props.location} />
        {/* TODO Recommended for Student */}
        <SourceSection location={this.props.location} />
        <TopicSection location={this.props.location} />
        <MyExercisesSection location={this.props.location} />
      </>
    );
  }
}
